import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function RealitySection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="w-full bg-cream py-16 md:py-24" ref={ref} data-id="element-216">
      <div className="max-w-prose mx-auto px-5" data-id="element-217">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-218">
          <p className="font-sans text-xs tracking-[0.15em] uppercase text-sage mb-4" data-id="element-219">
            Qué está pasando de verdad
          </p>

          <h2 className="font-sans font-bold text-2xl md:text-3xl text-charcoal mb-8 leading-tight" data-id="element-220">
            Sin jerga. Sin rodeos.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-serif text-lg md:text-xl leading-[1.85] text-charcoal/90 space-y-6" data-id="element-221">
          <p data-id="element-222">
            En esta etapa (30+ y, para muchas, perimenopausia), la hinchazón
            suele comportarse así:
          </p>

          <ul className="space-y-4 pl-0 list-none" data-id="element-223">
            <li className="flex items-start gap-3" data-id="element-224">
              <span className="w-1.5 h-1.5 rounded-full bg-terracotta mt-3 flex-shrink-0" data-id="element-225" />
              <span data-id="element-226">aparece con comidas "inocentes",</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-227">
              <span className="w-1.5 h-1.5 rounded-full bg-terracotta mt-3 flex-shrink-0" data-id="element-228" />
              <span data-id="element-229">se dispara con combinaciones específicas,</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-230">
              <span className="w-1.5 h-1.5 rounded-full bg-terracotta mt-3 flex-shrink-0" data-id="element-231" />
              <span data-id="element-232">empeora con cena tarde y estrés,</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-233">
              <span className="w-1.5 h-1.5 rounded-full bg-terracotta mt-3 flex-shrink-0" data-id="element-234" />
              <span data-id="element-235">se vuelve impredecible… y eso te rompe la confianza.</span>
            </li>
          </ul>

          <p data-id="element-236">
            Por eso te sientes confundida. No es solo el abdomen. Es el{' '}
            <strong className="text-charcoal" data-id="element-237">«no me reconozco.»</strong>
          </p>
        </motion.div>
      </div>
    </section>;
}